// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import { motion } from "framer-motion";

// export default function Attachments ({ setOpenDragDrop, setBase64Strings, setHasAttachment }) {
  
//   const [selectedFiles, setSelectedFiles] = useState([]);

//   const handleDragOver = (event) => {
//     event.preventDefault();
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     const files = Array.from(event.dataTransfer.files);
//     setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
//   };

//   const handleFileSelect = (event) => {
//     const files = Array.from(event.target.files);
//     setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
//   };

//   const convertFileToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64String = reader.result.split(",")[1];
//         resolve({
//           name: file.name,
//           contentType: file.type,
//           size: file.size,
//           base64: base64String,
//         });
//       };
//       reader.onerror = (error) => reject(error);
//       reader.readAsDataURL(file);
//     });
//   };

//   const handleFileChange = async (selectedFiles) => {
//     setOpenDragDrop(false);
//     const fileDataPromises = selectedFiles.map((file) => convertFileToBase64(file));

//     try {
//       const base64Results = await Promise.all(fileDataPromises);
//       console.log(base64Results);
//       setBase64Strings((prevBase64Strings) => [...prevBase64Strings, ...base64Results]);
//       setHasAttachment(true);
//     } catch (error) {
//       console.error("Error converting files: ", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to convert the attachments into base64!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0, scale: 0.95 }}
//       animate={{ opacity: 1, scale: 1 }}
//       exit={{ opacity: 0, scale: 0.95 }}
//       transition={{ duration: 0.25 }}
//       className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
//     >
//       <div className="w-full max-w-md bg-white rounded-lg shadow-lg flex flex-col overflow-hidden">
//         {/* Header */}
//         <div className="flex items-center justify-between px-4 py-2 border-b bg-[#365561] text-white">
//           <p className="text-sm font-semibold">Upload Files</p>
//           <i
//             className="fa-solid fa-xmark text-white cursor-pointer hover:text-gray-300"
//             onClick={() => setOpenDragDrop(false)}
//           />
//         </div>

//         {/* Dropzone */}
//         <div className="p-4 space-y-4 flex-1 overflow-y-auto">
//           <div
//             onDragOver={handleDragOver}
//             onDrop={handleDrop}
//             className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center bg-gray-50 cursor-pointer hover:border-blue-400 transition"
//           >
//             <p className="text-sm text-gray-600">Drag & Drop files here</p>
//             <label
//               htmlFor="fileInput"
//               className="text-blue-600 font-medium cursor-pointer hover:underline"
//             >
//               Browse Files
//             </label>
//             <input
//               type="file"
//               multiple
//               onChange={handleFileSelect}
//               className="hidden"
//               id="fileInput"
//             />
//           </div>

//           {selectedFiles.length > 0 && (
//             <div>
//               <p className="text-sm font-medium text-gray-800 mb-1">Selected Files:</p>
//               <ul className="space-y-2 max-h-40 overflow-y-auto pr-1">
//                 {selectedFiles.map((file, index) => {
//                   const fileType = file.type;
//                   let icon = "fa-file";

//                   if (fileType.includes("image")) icon = "fa-file-image";
//                   else if (fileType.includes("pdf")) icon = "fa-file-pdf";
//                   else if (fileType.includes("word")) icon = "fa-file-word";
//                   else if (fileType.includes("excel") || fileType.includes("spreadsheet")) icon = "fa-file-excel";
//                   else if (fileType.includes("powerpoint")) icon = "fa-file-powerpoint";
//                   else if (fileType.includes("zip") || fileType.includes("compressed")) icon = "fa-file-zipper";
//                   else if (fileType.includes("audio")) icon = "fa-file-audio";
//                   else if (fileType.includes("video")) icon = "fa-file-video";

//                   return (
//                     <li key={index} className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-md shadow-sm">
//                       <div className="flex items-center gap-3 overflow-hidden">
//                         <i className={`fa-solid ${icon} text-gray-600 text-lg`} />
//                         <span className="text-sm text-gray-800 truncate">{file.name}</span>
//                       </div>
//                       <button
//                         onClick={() => {
//                           const updated = [...selectedFiles];
//                           updated.splice(index, 1);
//                           setSelectedFiles(updated);
//                         }}
//                         className="text-red-500 hover:text-red-700 text-sm"
//                         title="Remove"
//                       >
//                         <i className="fa-solid fa-trash" />
//                       </button>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>
//           )}
//         </div>

//         {/* Footer Button */}
//         <div className="px-4 py-3 border-t flex justify-center bg-gray-50">
//           <button
//             className="flex items-center gap-2 text-white bg-[#365561] hover:bg-[#2f4751] transition px-4 py-2 rounded-md text-sm"
//             onClick={() => handleFileChange(selectedFiles)}
//           >
//             <i className="fa-regular fa-circle-check text-base"></i>
//             <span>Attach Files</span>
//           </button>
//         </div>
//       </div>
//     </motion.div>
//   );
// }


import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";
import { UrlContext } from "../../contexts/UrlContext";

const formatFileSize = (bytes = 0) => {
  const value = Number(bytes) || 0;
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
  return `${(value / 1024 / 1024).toFixed(value >= 10 * 1024 * 1024 ? 1 : 2)} MB`;
};

const getFileExtension = (name = "") => {
  const parts = String(name).split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

const getFileVisual = (name = "", contentType = "") => {
  const extension = getFileExtension(name);
  const mime = String(contentType || "").toLowerCase();

  if (extension === "pdf" || mime.includes("pdf")) {
    return {
      icon: "fa-file-pdf",
      badge: "PDF",
      iconClass: "text-rose-600",
      bgClass: "bg-rose-50",
    };
  }

  if (
    ["ppt", "pptx"].includes(extension) ||
    mime.includes("presentation") ||
    mime.includes("powerpoint")
  ) {
    return {
      icon: "fa-file-powerpoint",
      badge: extension === "ppt" ? "PPT" : "PPTX",
      iconClass: "text-orange-600",
      bgClass: "bg-orange-50",
    };
  }

  if (mime.startsWith("image/")) {
    return {
      icon: "fa-file-image",
      badge: extension ? extension.toUpperCase() : "IMG",
      iconClass: "text-sky-600",
      bgClass: "bg-sky-50",
    };
  }

  if (mime.includes("word") || ["doc", "docx"].includes(extension)) {
    return {
      icon: "fa-file-word",
      badge: extension ? extension.toUpperCase() : "DOC",
      iconClass: "text-blue-600",
      bgClass: "bg-blue-50",
    };
  }

  if (mime.includes("excel") || ["xls", "xlsx", "csv"].includes(extension)) {
    return {
      icon: "fa-file-excel",
      badge: extension ? extension.toUpperCase() : "XLS",
      iconClass: "text-emerald-600",
      bgClass: "bg-emerald-50",
    };
  }

  if (["zip", "rar", "7z"].includes(extension)) {
    return {
      icon: "fa-file-zipper",
      badge: extension.toUpperCase(),
      iconClass: "text-violet-600",
      bgClass: "bg-violet-50",
    };
  }

  return {
    icon: "fa-file",
    badge: extension ? extension.toUpperCase() : "FILE",
    iconClass: "text-slate-500",
    bgClass: "bg-slate-100",
  };
};

const fileToAttachmentPayload = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = String(reader.result || "");
      const base64 = result.includes(",") ? result.split(",")[1] : result;

      resolve({
        name: file.name,
        size: file.size,
        contentType: file.type || "application/octet-stream",
        base64,
      });
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const Attachments = ({
  setOpenDragDrop,
  setBase64Strings,
  setHasAttachment,
  projectID = null,
  initialSource = "upload",
}) => {
  const { API_URL } = useContext(UrlContext);

  const [source, setSource] = useState(
    initialSource === "sharepoint" ? "sharepoint" : "upload"
  );
  const [localFiles, setLocalFiles] = useState([]);
  const [sharePointFiles, setSharePointFiles] = useState([]);
  const [selectedSharePointIds, setSelectedSharePointIds] = useState([]);
  const [sharePointLoading, setSharePointLoading] = useState(false);
  const [sharePointLoaded, setSharePointLoaded] = useState(false);
  const [sharePointError, setSharePointError] = useState("");
  const [sharePointSearch, setSharePointSearch] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [attaching, setAttaching] = useState(false);

  const fileInputRef = useRef(null);
  const dragDepthRef = useRef(0);
  const autoFetchStartedRef = useRef(false);

  const pendingCount = localFiles.length + selectedSharePointIds.length;

  const filteredSharePointFiles = useMemo(() => {
    const query = sharePointSearch.trim().toLowerCase();
    if (!query) return sharePointFiles;

    return sharePointFiles.filter((file) =>
      String(file?.name || "").toLowerCase().includes(query)
    );
  }, [sharePointFiles, sharePointSearch]);

  const addLocalFiles = (fileList) => {
    const incomingFiles = Array.from(fileList || []);
    if (!incomingFiles.length || attaching) return;

    setLocalFiles((previous) => {
      const existing = new Set(
        previous.map(
          (file) => `${file.name}-${file.size}-${file.lastModified}`
        )
      );

      const nextFiles = [...previous];

      incomingFiles.forEach((file) => {
        const key = `${file.name}-${file.size}-${file.lastModified}`;
        if (!existing.has(key)) {
          existing.add(key);
          nextFiles.push(file);
        }
      });

      return nextFiles;
    });
  };

  const removeLocalFile = (index) => {
    if (attaching) return;
    setLocalFiles((previous) => previous.filter((_, fileIndex) => fileIndex !== index));
  };

  const fetchSharePointFiles = async () => {
    if (!projectID || sharePointLoading) return;

    const accessToken = localStorage.getItem("accesstoken");

    if (!accessToken) {
      setSharePointError("Your Microsoft access token is unavailable. Please sign in again.");
      return;
    }

    setSharePointLoading(true);
    setSharePointError("");

    try {
      const response = await fetch(`${API_URL}fetch-project-sharepoint-files`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          projectID,
          authToken: accessToken,
        }),
      });

      const data = await response.json();

      if (!response.ok || data?.status !== "success") {
        throw new Error(data?.text || "Could not load files from SharePoint.");
      }

      setSharePointFiles(Array.isArray(data?.files) ? data.files : []);
      setSharePointLoaded(true);
    } catch (error) {
      setSharePointFiles([]);
      setSharePointLoaded(true);
      setSharePointError(
        error?.message || "Could not load files from SharePoint."
      );
    } finally {
      setSharePointLoading(false);
    }
  };

  useEffect(() => {
    if (
      source === "sharepoint" &&
      projectID &&
      !sharePointLoaded &&
      !sharePointLoading &&
      !autoFetchStartedRef.current
    ) {
      autoFetchStartedRef.current = true;
      fetchSharePointFiles();
    }
  }, [source, projectID, sharePointLoaded, sharePointLoading]);

  const changeSource = (nextSource) => {
    if (attaching) return;

    setSource(nextSource);

    if (
      nextSource === "sharepoint" &&
      projectID &&
      !sharePointLoaded &&
      !sharePointLoading
    ) {
      fetchSharePointFiles();
    }
  };

  const toggleSharePointFile = (fileID) => {
    if (attaching) return;

    setSelectedSharePointIds((previous) =>
      previous.includes(fileID)
        ? previous.filter((id) => id !== fileID)
        : [...previous, fileID]
    );
  };

  const handleAttachFiles = async () => {
    if (pendingCount === 0 || attaching) return;

    setAttaching(true);
    setSharePointError("");

    try {
      const localAttachments = await Promise.all(
        localFiles.map(fileToAttachmentPayload)
      );

      let sharePointAttachments = [];

      if (selectedSharePointIds.length > 0) {
        const accessToken = localStorage.getItem("accesstoken");

        if (!accessToken) {
          throw new Error(
            "Your Microsoft access token is unavailable. Please sign in again."
          );
        }

        const response = await fetch(
          `${API_URL}fetch-sharepoint-attachment-files`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              projectID,
              authToken: accessToken,
              fileIDs: selectedSharePointIds,
            }),
          }
        );

        const data = await response.json();

        if (!response.ok || data?.status !== "success") {
          throw new Error(
            data?.text || "Could not attach the selected SharePoint files."
          );
        }

        sharePointAttachments = Array.isArray(data?.attachments)
          ? data.attachments
          : [];
      }

      const nextAttachments = [
        ...localAttachments,
        ...sharePointAttachments,
      ];

      if (!nextAttachments.length) {
        throw new Error("No files could be attached.");
      }

      setBase64Strings((previous) => [
        ...(Array.isArray(previous) ? previous : []),
        ...nextAttachments,
      ]);
      setHasAttachment(true);
      setOpenDragDrop(false);
    } catch (error) {
      setSharePointError(
        error?.message || "Could not attach one or more files."
      );
    } finally {
      setAttaching(false);
    }
  };

  const closeModal = () => {
    if (!attaching) setOpenDragDrop(false);
  };

  return (
    <motion.div
      className="absolute inset-0 z-[120] flex items-center justify-center p-3 sm:p-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.16 }}
    >
      <div
        className="absolute inset-0 bg-slate-950/45 backdrop-blur-[2px]"
        onClick={closeModal}
      />

      <motion.div
        initial={{ opacity: 0, y: 16, scale: 0.985 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 12, scale: 0.99 }}
        transition={{ type: "spring", stiffness: 340, damping: 28 }}
        className="relative flex max-h-[min(720px,calc(100vh-130px))] w-full max-w-[760px] flex-col overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_28px_90px_rgba(15,23,42,0.34)]"
        onClick={(event) => event.stopPropagation()}
      >
        {/* Header */}
        <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 bg-white px-5 py-4 sm:px-6">
          <div className="min-w-0">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-[#365561]/10 text-[#365561]">
                <i className="fa-solid fa-paperclip text-sm" />
              </span>
              <h3 className="truncate text-[17px] font-bold text-slate-900">
                Attach files
              </h3>
            </div>
            <p className="mt-1 text-xs leading-5 text-slate-500">
              Upload from your computer or choose PDF and PowerPoint files already stored with this project.
            </p>
          </div>

          <button
            type="button"
            disabled={attaching}
            onClick={closeModal}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full !border-0 !bg-transparent !p-0 !text-slate-400 transition hover:!bg-slate-100 hover:!text-slate-700 disabled:cursor-not-allowed disabled:opacity-40"
            aria-label="Close attachments"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* Source selector */}
        <div className="shrink-0 border-b border-slate-200 bg-slate-50/80 px-5 py-3 sm:px-6">
          <div className="grid grid-cols-2 gap-2 rounded-2xl bg-slate-200/60 p-1">
            <button
              type="button"
              disabled={attaching}
              onClick={() => changeSource("upload")}
              className={[
                "inline-flex min-h-[42px] items-center justify-center gap-2 rounded-xl !border-0 px-3 text-sm font-semibold transition",
                source === "upload"
                  ? "!bg-white !text-[#365561] shadow-sm"
                  : "!bg-transparent !text-slate-500 hover:!bg-white/60 hover:!text-slate-700",
              ].join(" ")}
            >
              <i className="fa-solid fa-arrow-up-from-bracket text-xs" />
              Computer
              {localFiles.length > 0 && (
                <span className="rounded-full bg-[#365561]/10 px-1.5 py-0.5 text-[10px] font-bold text-[#365561]">
                  {localFiles.length}
                </span>
              )}
            </button>

            <button
              type="button"
              disabled={!projectID || attaching}
              onClick={() => changeSource("sharepoint")}
              className={[
                "inline-flex min-h-[42px] items-center justify-center gap-2 rounded-xl !border-0 px-3 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-45",
                source === "sharepoint"
                  ? "!bg-white !text-[#365561] shadow-sm"
                  : "!bg-transparent !text-slate-500 hover:!bg-white/60 hover:!text-slate-700",
              ].join(" ")}
            >
              <i className="fa-solid fa-folder-open text-xs" />
              Project files
              {selectedSharePointIds.length > 0 && (
                <span className="rounded-full bg-[#365561]/10 px-1.5 py-0.5 text-[10px] font-bold text-[#365561]">
                  {selectedSharePointIds.length}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="min-h-0 flex-1 overflow-y-auto bg-white px-5 py-4 sm:px-6 sm:py-5">
          {source === "upload" ? (
            <div>
              <input
                ref={fileInputRef}
                type="file"
                multiple
                className="hidden"
                disabled={attaching}
                onChange={(event) => {
                  addLocalFiles(event.target.files);
                  event.target.value = "";
                }}
              />

              <div
                onDragEnter={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (attaching) return;
                  dragDepthRef.current += 1;
                  setDragActive(true);
                }}
                onDragOver={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (!attaching) setDragActive(true);
                }}
                onDragLeave={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  dragDepthRef.current = Math.max(0, dragDepthRef.current - 1);
                  if (dragDepthRef.current === 0) setDragActive(false);
                }}
                onDrop={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  dragDepthRef.current = 0;
                  setDragActive(false);
                  addLocalFiles(event.dataTransfer.files);
                }}
                onClick={() => !attaching && fileInputRef.current?.click()}
                className={[
                  "flex min-h-[205px] cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed px-6 py-7 text-center transition",
                  dragActive
                    ? "border-[#365561] bg-[#365561]/5 shadow-[inset_0_0_0_1px_rgba(54,85,97,0.08)]"
                    : "border-slate-300 bg-slate-50/70 hover:border-[#365561]/55 hover:bg-slate-50",
                  attaching ? "pointer-events-none opacity-60" : "",
                ].join(" ")}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#365561]/10 text-[#365561]">
                  <i className="fa-solid fa-cloud-arrow-up text-2xl" />
                </div>

                <p className="mt-4 text-sm font-bold text-slate-800">
                  {dragActive ? "Drop files to add them" : "Drag & drop files here"}
                </p>
                <p className="mt-1 text-xs text-slate-500">
                  or click to browse your computer
                </p>
                <span className="mt-4 inline-flex rounded-xl bg-[#365561] px-4 py-2 text-xs font-semibold text-white shadow-sm">
                  Select files
                </span>
              </div>

              {localFiles.length > 0 && (
                <div className="mt-4">
                  <div className="mb-2 flex items-center justify-between">
                    <span className="text-xs font-bold uppercase tracking-[0.08em] text-slate-500">
                      Ready to attach
                    </span>
                    <span className="text-xs font-semibold text-slate-400">
                      {localFiles.length} file{localFiles.length === 1 ? "" : "s"}
                    </span>
                  </div>

                  <div className="space-y-2">
                    {localFiles.map((file, index) => {
                      const visual = getFileVisual(file.name, file.type);

                      return (
                        <div
                          key={`${file.name}-${file.size}-${file.lastModified}`}
                          className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-3 py-2.5 shadow-sm"
                        >
                          <span
                            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${visual.bgClass} ${visual.iconClass}`}
                          >
                            <i className={`fa-solid ${visual.icon}`} />
                          </span>

                          <div className="min-w-0 flex-1">
                            <p className="truncate text-xs font-bold text-slate-800">
                              {file.name}
                            </p>
                            <p className="mt-0.5 text-[11px] text-slate-500">
                              {formatFileSize(file.size)} · {visual.badge}
                            </p>
                          </div>

                          <button
                            type="button"
                            disabled={attaching}
                            onClick={(event) => {
                              event.stopPropagation();
                              removeLocalFile(index);
                            }}
                            className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full !border-0 !bg-transparent !text-slate-400 transition hover:!bg-red-50 hover:!text-red-500"
                            aria-label={`Remove ${file.name}`}
                          >
                            <i className="fa-solid fa-xmark text-xs" />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              {!projectID ? (
                <div className="flex min-h-[260px] flex-col items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 px-6 text-center">
                  <i className="fa-solid fa-folder-minus text-3xl text-slate-300" />
                  <p className="mt-4 text-sm font-bold text-slate-700">
                    No project selected
                  </p>
                  <p className="mt-1 max-w-sm text-xs leading-5 text-slate-500">
                    Project files are available only when the email composer is opened from a project.
                  </p>
                </div>
              ) : (
                <>
                  <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center">
                    <div className="relative min-w-0 flex-1">
                      <i className="fa-solid fa-magnifying-glass pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[11px] text-slate-400" />
                      <input
                        value={sharePointSearch}
                        onChange={(event) => setSharePointSearch(event.target.value)}
                        placeholder="Search project files"
                        className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 pl-9 pr-3 text-sm text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-[#365561]/50 focus:bg-white focus:ring-2 focus:ring-[#365561]/10"
                      />
                    </div>

                    <button
                      type="button"
                      disabled={sharePointLoading || attaching}
                      onClick={fetchSharePointFiles}
                      className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-xl !border !border-slate-200 !bg-white px-3 !text-xs !font-semibold !text-slate-600 transition hover:!border-slate-300 hover:!bg-slate-50 hover:!text-[#365561] disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      <i
                        className={`fa-solid ${
                          sharePointLoading ? "fa-spinner fa-spin" : "fa-rotate-right"
                        }`}
                      />
                      Refresh
                    </button>
                  </div>

                  <div className="mb-3 flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2 text-[11px] text-slate-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="fa-solid fa-folder text-[#365561]" />
                      SharePoint · Project folder
                    </span>
                    <span>PDF, PPT and PPTX</span>
                  </div>

                  {sharePointError && (
                    <div className="mb-3 rounded-xl border border-red-200 bg-red-50 px-3 py-2.5 text-xs leading-5 text-red-600">
                      <i className="fa-solid fa-circle-exclamation mr-2" />
                      {sharePointError}
                    </div>
                  )}

                  {sharePointLoading ? (
                    <div className="flex min-h-[250px] flex-col items-center justify-center">
                      <span className="h-9 w-9 animate-spin rounded-full border-[3px] border-slate-200 border-t-[#365561]" />
                      <p className="mt-4 text-sm font-semibold text-slate-700">
                        Loading project files...
                      </p>
                    </div>
                  ) : sharePointLoaded && filteredSharePointFiles.length === 0 ? (
                    <div className="flex min-h-[250px] flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-6 text-center">
                      <i className="fa-regular fa-folder-open text-3xl text-slate-300" />
                      <p className="mt-4 text-sm font-bold text-slate-700">
                        {sharePointSearch ? "No matching files" : "No project files found"}
                      </p>
                      <p className="mt-1 max-w-sm text-xs leading-5 text-slate-500">
                        {sharePointSearch
                          ? "Try a different search term."
                          : "This folder does not currently contain any PDF, PPT or PPTX files."}
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {filteredSharePointFiles.map((file) => {
                        const selected = selectedSharePointIds.includes(file.id);
                        const visual = getFileVisual(file.name, file.mimeType);

                        return (
                          <button
                            key={file.id}
                            type="button"
                            disabled={attaching}
                            onClick={() => toggleSharePointFile(file.id)}
                            className={[
                              "flex w-full items-center gap-3 rounded-2xl !border px-3 py-3 text-left transition",
                              selected
                                ? "!border-[#365561]/45 !bg-[#365561]/5 shadow-[0_5px_16px_rgba(54,85,97,0.08)]"
                                : "!border-slate-200 !bg-white hover:!border-slate-300 hover:!bg-slate-50",
                            ].join(" ")}
                          >
                            <span
                              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${visual.bgClass} ${visual.iconClass}`}
                            >
                              <i className={`fa-solid ${visual.icon} text-lg`} />
                            </span>

                            <span className="min-w-0 flex-1">
                              <span className="block truncate text-xs font-bold text-slate-800">
                                {file.name}
                              </span>
                              <span className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-slate-500">
                                <span>{formatFileSize(file.size)}</span>
                                <span className="text-slate-300">•</span>
                                <span>{file.fileType || visual.badge}</span>
                                {file.lastModifiedDateTime && (
                                  <>
                                    <span className="text-slate-300">•</span>
                                    <span>
                                      {new Date(file.lastModifiedDateTime).toLocaleDateString()}
                                    </span>
                                  </>
                                )}
                              </span>
                            </span>

                            <span
                              className={[
                                "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition",
                                selected
                                  ? "border-[#365561] bg-[#365561] text-white"
                                  : "border-slate-300 bg-white text-transparent",
                              ].join(" ")}
                            >
                              <i className="fa-solid fa-check text-[9px]" />
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex shrink-0 items-center justify-between gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:px-6">
          <div className="min-w-0 text-xs text-slate-500">
            {pendingCount > 0 ? (
              <span>
                <strong className="text-slate-700">{pendingCount}</strong> file{pendingCount === 1 ? "" : "s"} selected
              </span>
            ) : (
              <span>Select at least one file to continue</span>
            )}
          </div>

          <div className="flex shrink-0 items-center gap-2">
            <button
              type="button"
              disabled={attaching}
              onClick={closeModal}
              className="rounded-xl !border !border-slate-200 !bg-white px-4 py-2 !text-sm !font-semibold !text-slate-600 transition hover:!bg-slate-100 hover:!text-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Cancel
            </button>

            <button
              type="button"
              disabled={pendingCount === 0 || attaching}
              onClick={handleAttachFiles}
              className="inline-flex min-w-[132px] items-center justify-center gap-2 rounded-xl !border-0 !bg-[#365561] px-4 py-2 !text-sm !font-semibold !text-white shadow-[0_8px_20px_rgba(54,85,97,0.18)] transition hover:!bg-[#2e4a54] hover:!text-white disabled:cursor-not-allowed disabled:!bg-slate-300 disabled:!text-white disabled:opacity-100"
            >
              {attaching ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin text-xs" />
                  Attaching...
                </>
              ) : (
                <>
                  <i className="fa-solid fa-paperclip text-xs" />
                  Attach files
                </>
              )}
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Attachments;
